import React, { useState } from "react";

const SliderPage = (props) => {
  const [value, setValue] = useState(0);

  const setVal = (val) => {
    setValue(val.target.value);
    props.parentCallback(val.target.value);
  };

  return (
    <>
      <div style={{ height: "100%" }}>
        {props.altType ? (
          <>
            {" "}
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <label htmlFor="customRange1">
                <strong>{props.title}{":"}</strong>
              </label>
              <p>{props.value}%</p>
            </div>
            <input
              type="range"
              style={{ cursor: "pointer" }}
              value={props.value}
              onChange={setVal}
              min={0}
              max={100}
              className="custom-range"
              id="customRange1"
            />
          </>
        ) : (
          <>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <label htmlFor="customRange1">
                <strong>OEE meta:</strong>
              </label>
              <p>{value}%</p>
            </div>
            <input
              type="range"
              style={{ cursor: "pointer" }}
              value={value}
              onChange={setVal}
              min={0}
              max={100}
              className="custom-range"
              id="customRange1"
            />
          </>
        )}
      </div>
    </>
  );
};

export default SliderPage;